import React, { FC } from 'react'

import { Alert, Collapse } from '@mui/material'
import Box from '@mui/material/Box'

import { NotificationProps } from './types'

export const Notification: FC<NotificationProps> = ({
  children,
  open,
  colorType,
  icon,
  onClose,
  onClick,
  action,
  styles = {},
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Collapse in={open}>
        <Alert
          color={colorType}
          severity={colorType}
          action={action}
          icon={icon}
          onClick={onClick}
          onClose={onClose}
          sx={{ ...styles }}
        >
          {children}
        </Alert>
      </Collapse>
    </Box>
  )
}
